<template>
  <div
    v-show="visible" class="td-viewer"
    @mousewheel="onMouseWheel"
  >
    <div class="td-viewer__header">
      <!-- <div class="td-viewer__operate">
        <template v-if="canFullscreen">
          <a title="最小化" @click="$emit('minimize')">
            <i class="td-icon-minimize" />
          </a>
          <a
            title="最大化" v-if="!fullscreen"
            @click="$emit('fullscreen')"
          >
            <i class="td-icon-maximize" />
          </a>
          <a @click="$emit('restore')" v-else>
            <i class="td-icon-restore" title="还原" />
          </a>
        </template>
        <a href="javascript:;">
          <i class="td-icon-close" title="关闭" />
        </a>
      </div> -->
    </div>
    <div class="td-viewer__body" ref="container">
      <!-- v-show="!isLoading"  -->
      <img
        draggable="true"
        alt ref="image"
        :src="currentShowingImg"
        :class="{ 'is-origin-ratio': isShowingActualRatio }" :style="imageStyle"
        @load="onImageLoaded"
        @error="onImageError" @dragstart="onDragStart"
        @dragover="onDragOver"
      >
      <template v-if="isSrcPropArray">
        <span
          class="td-viewer__button td-viewer__button--left" :class="{ 'is-disabled': isArrowDisabled.left }"
          @click="changeImage(-1)"
        >
          <i class="td-icon-arrow-left" />
        </span>
        <span
          class="td-viewer__button td-viewer__button--right" :class="{ 'is-disabled': isArrowDisabled.right }"
          @click="changeImage(1)"
        >
          <i class="td-icon-arrow-right" />
        </span>
      </template>
      <!-- <div v-if="isLoading" class="td-viewer__loading">
        <i class="td-icon-loading" />
        <p>图片加载中...</p>
      </div> -->
      <div v-if="isError" class="td-viewer__loading">
        <p>图片加载失败</p>
      </div>
    </div>
    <!-- <div class="td-viewer__footer">
      <a :title="buttonText.zoomIn" @click="zoomIn">
        <i class="td-icon-magnify" />
      </a>
      <a :title="buttonText.zoomOut" @click="zoomOut">
        <i class="td-icon-minify" />
      </a>
      <a
        :title="buttonText.ratioOptimal" v-if="isShowingActualRatio"
        @click="showOptimalRatio"
      >
        <i class="td-icon-ratio-optimal" />
      </a>
      <a
        :title="buttonText.ratioOptimal" v-else
        @click="showActualRatio"
      >
        <i class="td-icon-ratio" />
      </a>
      <a :title="buttonText.rotate" @click="rotate">
        <i class="td-icon-refresh" />
      </a>
      <a :title="buttonText.download" @click="download(currentShowingImg)">
        <i class="td-icon-download" />
      </a>
    </div> -->
  </div>
</template>

<script>
import throttle from 'lodash/throttle'
export default {
  name: 'TdViewerImage',
  props: {
    src: {
      type: [String, Array],
      require: true,
      default: () => [],
    },
    maxScaleRatio: {
      type: Number,
      default: 5,
    },
    minScaleRatio: {
      type: Number,
      default: 0.107374,
    },
    visible: {
      type: Boolean,
      default: true,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    canFullscreen: {
      type: Boolean,
      default: true,
    },
    customButtonText: {
      type: Object,
      default: () => ({}),
    },
    useBrowserDownload: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      isLoading: true,
      isError: false,
      isShowingActualRatio: false,
      scaleRatio: 1,
      rotateDegree: 0,
      index: 0,
      dragPosition: {
        x: 0,
        y: 0,
      },
      deltaPostion: {
        x: 0,
        y: 0,
      },
      transparentImage: null,
      buttonText: {
        zoomIn: '放大',
        zoomOut: '缩小',
        ratioOptimal: '最佳比例',
        ratioOrigin: '实际大小',
        rotate: '旋转',
        download: '取回',
      },
    }
  },
  computed: {
    isSrcPropArray () {
      return Array.isArray(this.src)
    },
    imgCount () {
      return this.isSrcPropArray ? this.src.length : 1
    },
    currentShowingImg () {
      return this.isSrcPropArray ? this.src[this.index] : this.src
    },
    isArrowDisabled () {
      return {
        left: this.index === 0,
        right: this.index === this.imgCount - 1,
      }
    },
    imageStyle () {
      const centerize = this.isShowingActualRatio ? 'translate(-50%, -50%)' : ''
      const scale = `scale(${this.scaleRatio})`
      const rotate = `rotate(${this.rotateDegree}deg)`

      let translate = `translate(${this.deltaPostion.x}px, ${this.deltaPostion.y}px)`
      switch (this.rotateDegree) {
        case 90:
          translate = `translate(${this.deltaPostion.y}px, ${-this.deltaPostion.x}px)`
          break
        case 180:
          translate = `translate(${-this.deltaPostion.x}px, ${-this.deltaPostion.y}px)`
          break
        case 270:
          translate = `translate(${-this.deltaPostion.y}px, ${this.deltaPostion.x}px)`
          break
        default:
          break
      }
      const transform = `transform: ${centerize} ${scale} ${rotate} ${translate};`
      return transform
    },
  },
  watch: {
    currentShowingImg: {
      immediate: true,
      handler: function () {
        this.isLoading = true
        this.isError = false
      },
    },
    visible (val) {
      this.scaleRatio = 1
      this.rotateDegree = 0
      this.isShowingActualRatio = false
      this.resetDragPosition()
    },
  },
  mounted () {
    const img = new Image()
    // // 加载一个1*1 px的透明图片，替换默认预览图
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
    this.transparentImage = img
    // this.buttonText = {
    //   ...this.buttonText,
    //   ...this.customButtonText,
    // }
  },
  methods: {
    showActualRatio () {
      this.isShowingActualRatio = true
      this.scaleRatio = 1
      this.resetDragPosition()
    },
    showOptimalRatio () {
      this.isShowingActualRatio = false
      this.scaleRatio = 1
      this.resetDragPosition()
    },
    zoomIn () {
      let result = this.scaleRatio
      result = result >= 1 ? result + 0.2 : result * 1.25
      if (result <= this.maxScaleRatio) {
        this.scaleRatio = result
      }
    },
    zoomOut () {
      let result = this.scaleRatio
      result = result >= 1.2 ? result - 0.2 : result * 0.8
      if (result >= this.minScaleRatio) {
        this.scaleRatio = result
      }
    },
    changeImage (delta) {
      const result = this.index + delta
      if (result >= 0 && result < this.imgCount) {
        this.index = result
        this.reset()
      }
    },
    rotate () {
      this.rotateDegree = (this.rotateDegree + 90) % 360
    },
    onMouseWheel (e) {
      e.preventDefault()
      if (e.deltaY > 0) {
        this.zoomOut()
      } else {
        this.zoomIn()
      }
    },
    reset () {
      this.isLoading = true
      this.isError = false
      this.scaleRatio = 1
      this.rotateDegree = 0
      this.resetDragPosition()
    },
    download (imgUrl) {
      this.$emit('download', imgUrl)
      if (this.useBrowserDownload) {
        const image = new Image()
        // 解决跨域 canvas污染问题
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = function () {
          const canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          const context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          const url = canvas.toDataURL('image/png') // 图片转为base64格式
          const a = document.createElement('a')
          const e = new MouseEvent('click')
          a.download = '图片'
          a.href = url
          a.dispatchEvent(e)
        }
        // imgUrl即为要下载图片的路径
        image.src = imgUrl + '?time=' + new Date().valueOf() // 加时间戳，防止重用缓存，会导致跨域问题
      }
    },
    onImageLoaded () {
      this.isLoading = false
      this.isError = false
    },
    onImageError () {
      this.isLoading = false
      this.isError = true
    },
    onDragStart (e) {
      e.dataTransfer.setDragImage(this.transparentImage, 10, 10)
      this.dragPosition.x = e.clientX
      this.dragPosition.y = e.clientY
    },
    onDragOver: throttle(function (e) {
      this.deltaPostion.x = this.deltaPostion.x + (e.clientX - this.dragPosition.x)
      this.deltaPostion.y = this.deltaPostion.y + (e.clientY - this.dragPosition.y)
      this.dragPosition.x = e.clientX
      this.dragPosition.y = e.clientY
    }, 10),
    resetDragPosition () {
      this.deltaPostion = {
        x: 0,
        y: 0,
      }
      this.dragPosition = {
        x: 0,
        y: 0,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.is-origin-ratio {
  left: 50%;
  top: 50%;
  width: unset;
  height: unset;
}

.td-viewer__loading {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.td-viewer {
  position: relative;
  display: flex;
  flex-direction: column;
  background: transparent;
  width: 100%;
  height: 100%;

  img {
    &:hover {
      cursor: grab;
    }
  }

  &__header {
    display: none;
  }

  &__body {
    flex: 1;
    overflow: auto;
    overscroll-behavior: contain;

    img {
      position: absolute;
      width: 100%;
      height: 100% !important;
      display: block;
      margin: 0 auto;
      object-fit: contain;
    }
  }

  &__footer {
    z-index: 9;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50PX;
    background: #000;

    a {
      cursor: pointer;
      margin: 0 12px;

      i {
        font-size: 24PX;
        color: #fff;
      }
    }

    .td-icon-download {
      display: none;
    }
  }
}
</style>
